module.exports = __webpack_public_path__ + "img/single_product_1.f2ab208b.png";